<div>
  <div class="uk-margin-bottom" [id]="field().id" style="scroll-margin-top: 80px;">
    @if (field()?.label?.text) {
      <label [for]="field().name" class="uk-form-label {{field().label.cssClasses}}"  style="{{field().label.style}}"
             [innerHTML]="field().form.mandatory ? appendAsterisk($safeNavigationMigration(field().label?.text)) : field().label.text">
      </label>
    }
  </div>

  @if (field()?.form?.description?.showLess) {
    @if (field().form.description.text) {
      <div class="uk-form-description uk-text-small uk-margin-bottom {{field().form.description.cssClasses}}"
           style="{{field().form.description.style}}">
        <read-more-text [maxHeight]="46" [text]="field().form.description.text"></read-more-text>
      </div>
    }
  } @else {
    @if (field()?.form?.description?.text) {
      <div class="uk-form-description uk-text-small uk-margin-bottom {{field().form.description.cssClasses}}"
           style="{{field().form.description.style}}"
           [innerHTML]="field().form.description.text | safeUrl: 'html'">
      </div>
    }
  }

  @let fieldType = field()?.typeInfo?.type || null;
  @if (fieldType === 'composite') {
    <div class="uk-card card-simple uk-card-body uk-animation-scale-up">

      @if (field().typeInfo.properties['checkbox']) {

        <table class="uk-table uk-table-middle uk-margin-remove">
          <thead>
          <tr>
            <th>Option label</th>
            <th class="uk-width-auto"></th>
          </tr>
          </thead>
          <tbody>
            @for (subField of field().subFields; let i = $index; let first = $first; let last = $last; track subField.id) {
              <tr class="uk-animation-slide-top-small">
                <td>
                  <div class="uk-flex uk-flex-middle uk-disabled">
                    <input id="checkbox-{{i}}" class="uk-checkbox uk-margin-small-right" type="checkbox">
                    <label for="checkbox-{{i}}" class="uk-checkbox-label">
                      {{ subField.typeInfo.properties['label'] || 'undefined' }}
                    </label>
                  </div>
                </td>
                <td class="uk-text-nowrap">
                  @if (!first) {
                    <span class="material-symbols-outlined uk-cursor-pointer" (click)="moveCheckbox(i, i-1)">arrow_circle_up</span>
                  }
                  @if (!last) {
                    <span class="material-symbols-outlined uk-cursor-pointer" (click)="moveCheckbox(i, i+1)">arrow_circle_down</span>
                  }
                  <span class="material-symbols-outlined uk-cursor-pointer" (click)="deleteCheckbox(i)">remove</span>
                </td>
              </tr>
            }
            <tr>
              <td>
                <input id="checkbox-label" #labelInput class="uk-input" type="text" placeholder="Set the label"
                       [(ngModel)]="checkboxLabel"
                       [ngModelOptions]="{standalone: true}">
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <div class="uk-flex uk-flex-right uk-margin-small-top">
          <button class="uk-button uk-button-default uk-button-small" type="button" (click)="addCheckbox()">
            <span class="material-icons" style="font-size: 16px; vertical-align: middle;">add</span> Add option
          </button>
        </div>
      } @else {

        @for (subField of field().subFields; track subField.id; let i = $index; let first = $first; let last = $last;) {
          <div class="uk-margin-bottom">
            <div class="uk-card uk-card-body card-simple uk-padding-small uk-animation-scale-up"
                 [ngClass]="{'highlight-field': fbService.isFieldActive(subField)}"
                 (click)="$event.stopPropagation(); fbService.fieldSelection(subField)">
              <div class="uk-card-title uk-flex uk-flex-middle uk-flex-right">
                <span class="uk-text-bold uk-margin-small-right uk-flex uk-flex-middle">
                  <input id="fieldMandatory-{{subField.id}}" class="uk-checkbox" type="checkbox"
                         [(ngModel)]="subField.form.mandatory">
                  <label for="fieldMandatory-{{subField.id}}" class="uk-checkbox-label uk-margin-small-left">Require this field</label>
                </span>
                @if (subField.typeInfo.type !== 'radio') {
                  <span class="uk-text-bold uk-margin-small-right uk-flex uk-flex-middle">
                    <input id="multiplicity-{{subField.id}}" class="uk-checkbox" type="checkbox"
                           [(ngModel)]="subField.typeInfo.multiplicity">
                    <label for="multiplicity-{{subField.id}}" class="uk-checkbox-label uk-margin-small-left">
                      Allow multiplicity
                    </label>
                  </span>
                }
                <span class="material-icons uk-margin-small-right" (click)="fbService.duplicateField(subField, field())">
                content_copy
              </span>
                <span class="material-icons uk-cursor-pointer" (click)="fbService.deleteField(i, field())">delete</span>
              </div>
              <div class="uk-grid uk-grid-column-collapse">
                <app-field-templates [field]="subField" class="uk-width-expand"></app-field-templates>
                @if (field().subFields.length > 1) {
                  <div class="uk-width-auto uk-margin-small-left uk-flex uk-flex-column uk-flex-center">
                    @if (!first) {
                      <div class="uk-margin-small" data-uk-tooltip="Move up">
                        <span class="material-icons uk-cursor-pointer" (click)="fbService.move(i, i-1, field())">north</span>
                      </div>
                    }
                    @if (!last) {
                      <div class="uk-margin-small" data-uk-tooltip="Move down">
                        <span class="material-icons uk-cursor-pointer" (click)="fbService.move(i, i+1, field())">south</span>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <div class="uk-grid">
          <!--        <div>-->
          <!--          <div class="uk-card card-simple">-->
          <!--            <div class="uk-border-rounded border-dashed">-->
          <!--              <a class="uk-flex uk-flex-center uk-flex-middle uk-text-decoration-none uk-padding-small"-->
          <!--                 (click)="$event.stopPropagation(); fbService.addCompositeField(field); fbService.setSideMenuSettingsType('field')">-->
          <!--                Add group <span class="material-icons">add</span>-->
          <!--              </a>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
          <div class="uk-width-1-1">
            <div class="uk-card card-simple">
              <div class="uk-border-rounded border-dashed">
                <a class="uk-flex uk-flex-center uk-flex-middle uk-text-decoration-none uk-padding-small"
                   (click)="$event.stopPropagation(); fbService.setCurrentField(field()); fbService.setSideMenuSettingsType('fieldSelector')">
                  Add Field <span class="material-icons">add</span>
                </a>
              </div>
            </div>
          </div>
        </div>

      }

    </div>
  }
  @else if (fieldType === 'richText') {
    <div class="uk-margin-medium-top uk-animation-scale-up uk-disabled">
      <app-rich-text-editor [placeholder]="field().form.placeholder ?? ''" [readonly]="true"></app-rich-text-editor>
    </div>
  } @else if (fieldType === 'string' || fieldType === 'email' || fieldType === 'phone' || fieldType === 'url') {
    <input class="uk-input uk-animation-scale-up uk-disabled" [placeholder]="field().form.placeholder ?? ''">
  } @else if (fieldType === 'largeText') {
    <textarea class="uk-textarea uk-animation-scale-up uk-disabled" [placeholder]="field().form.placeholder ?? ''"></textarea>
    @if (textProperties.maxLength) {
      <div class="uk-animation-scale-up" style="float: right;">
        <span> 0/ {{ textProperties.maxLength }}</span>
      </div>
    }
  } @else if (fieldType === 'number') {
    <input class="uk-input uk-animation-scale-up uk-disabled" [placeholder]="field().form.placeholder ?? ''">
  } @else if (fieldType === 'date') {
    <div class="input-wrapper flat uk-width-9-10" >
      <div class="input-box" tabindex="0">

        <div class="uk-flex uk-flex-middle" tabindex="0" >
          <div class="input uk-text-truncate">
            {{ field().form.placeholder ?? '' }}
          </div>
          <div class="uk-margin-small-left icon">
            <span class="uk-flex">
              <span class="material-symbols-outlined" style="font-size: 20px;">today</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="uk-dropdown" data-uk-dropdown="mode: click; flip: false; shift: false" style="z-index: 1000"
         (click)="$event.stopPropagation()">
      <mat-calendar></mat-calendar>
    </div>
  } @else if (fieldType === 'select' || fieldType === 'radio') {
    <table class="uk-table uk-table-middle uk-margin-remove uk-animation-scale-up">
      <thead>
      <tr>
        <th>Option label</th>
        <th>Stored value</th>
        <th class="uk-width-auto"></th>
      </tr>
      </thead>
      <tbody>
        @for (value of field().typeInfo.values; let i = $index; let first = $first; let last = $last; track value.id + '-' + $index) {
          <tr class="uk-animation-slide-top-small">
            <td>
              <div class="uk-flex uk-flex-middle">
                <span class="material-symbols-outlined uk-text-muted uk-margin-small-right" style="font-size: 18px;">
                  {{ fieldType === 'radio' ? 'radio_button_unchecked' : 'arrow_drop_down_circle' }}
                </span>
                <input class="uk-input" type="text" placeholder="Set the label"
                       [ngModel]="value.label" (ngModelChange)="updateValue(i, $event)" [ngModelOptions]="{standalone: true}">
              </div>
            </td>
            <td>
              <div class="uk-inline uk-width-1-1">
                @if (sameLabelValue) {
                  <span class="uk-form-icon uk-form-icon-flip" data-uk-icon="icon: lock"></span>
                }
                <input class="uk-input" type="text" [disabled]="sameLabelValue"
                       [(ngModel)]="value.id" [ngModelOptions]="{standalone: true}"
                       [placeholder]="sameLabelValue ? 'Same as label' : 'Set a Value'">
              </div>
            </td>
            <td class="uk-text-nowrap">
              @if (!first) {
                <span class="material-symbols-outlined uk-cursor-pointer" (click)="move(i, i-1)">arrow_circle_up</span>
              }
              @if (!last) {
                <span class="material-symbols-outlined uk-cursor-pointer" (click)="move(i, i+1)">arrow_circle_down</span>
              }
              <span class="material-symbols-outlined uk-cursor-pointer" (click)="removeOption(i)">remove</span>
            </td>
          </tr>
        }
        <tr>
          <td>
            <input id="radio-label" #labelInput class="uk-input" type="text" placeholder="Set the label"
                   [(ngModel)]="option.label"
                   [ngModelOptions]="{standalone: true}">
          </td>
          <td>
            <div class="uk-inline uk-width-1-1">
              @if (sameLabelValue) {
                <span class="uk-form-icon uk-form-icon-flip" data-uk-icon="icon: lock"></span>
              }
              <input id="radio-value" class="uk-input" type="text" [disabled]="sameLabelValue"
                     [(ngModel)]="option.id" [ngModelOptions]="{standalone: true}"
                     [placeholder]="sameLabelValue ? 'Same as label' : 'Set a Value'">
            </div>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>

    <div class="uk-flex uk-flex-middle uk-flex-between uk-margin-small-top">
      <span class="uk-text-small">
        <input id="value" type="checkbox" class="uk-checkbox uk-margin-small-right"
               [(ngModel)]="sameLabelValue" [ngModelOptions]="{standalone: true}">
        <label for="value" class="uk-radio-label">Same value as the label</label>
      </span>
      <button class="uk-button uk-button-default uk-button-small" type="button" (click)="addOption()">
        <span class="material-icons" style="font-size: 16px; vertical-align: middle;">add</span> Add option
      </button>
    </div>
  }

  @if (field()?.form.suggestion.text) {
    <div class="uk-margin-top">
      <div class="uk-suggestion {{field().form.suggestion.cssClasses}}"
           style="{{field().form.suggestion.style}}" [innerHTML]="field().form.suggestion.text">
      </div>
    </div>
  }

</div>

<!--<pre>{{ fbService.currentField() | json }}</pre>-->
